<ng-container *ngIf="initialized">

    <p-tabs [(value)]="tabIndex" (valueChange)="onActiveItemChange($event)">
        <p-tablist>
            @for(item of tabItems; track item) {
                <p-tab [value]="item.id">{{ item.label }}</p-tab>
            }
        </p-tablist>
    </p-tabs>

    @if (tabIndex == 'ci.ContractObject') {
        <mvs-widget *ngIf="widgetContractInsurableObject"
                    [widgetData]="widgetContractInsurableObject">
        </mvs-widget>
    }

    @if (tabIndex == 'ci.ObjectCoverages') {
        <mvs-widget *ngIf="widgetObjectCoverages"
                    [widgetData]="widgetObjectCoverages">
        </mvs-widget>
    }

</ng-container>